module.exports = __webpack_public_path__ + "img/A58A0804_min.fd1b2b91.jpg";